import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Chip,
  Divider,
  CardContent,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import { StyledCard } from "../common/StyledCard";
import { TeacherSubjectResponseDto } from "../../shared/dtos/teacherSubject/TeacherSubjectResponseDto";

interface TeacherSubjectCardProps {
  teacherSubject: TeacherSubjectResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const TeacherSubjectCard: React.FC<TeacherSubjectCardProps> = ({
  teacherSubject,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <CardContent
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Header */}
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box>
            <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
              <PersonIcon fontSize="small" sx={{ color: "text.secondary" }} />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {teacherSubject.teacherName}
              </Typography>
            </Stack>
            <Chip
              label={teacherSubject.subjectName}
              size="small"
              color="secondary"
              variant="outlined"
              icon={<MenuBookIcon fontSize="small" />}
              sx={{
                mt: 1,
                height: 24,
                fontSize: "0.75rem",
                fontWeight: 700,
              }}
            />
          </Box>
          <Stack direction="row">
            {onEdit && (
              <Tooltip title="Edit Allocation">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete Allocation">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        {/* Footer Details */}
        <Box sx={{ flexGrow: 1 }}>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <CalendarTodayIcon
              fontSize="small"
              sx={{ color: "action.active" }}
            />
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              <b>Academic Year:</b> {teacherSubject.academicYearName}
            </Typography>
          </Stack>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default TeacherSubjectCard;
